module.exports = "<span *ngIf=\"column.isHtml\"\n  [innerHTML]=\"data\">\n</span>\n<span *ngIf=\"!column.isHtml\">{{ data }}</span>";